export default __webpack_public_path__ + "static/media/mapNew.aabc3ca5.svg";